export default __webpack_public_path__ + "static/media/pic4.f85adf5c.jpg";